import React from 'react';
import ServicePage from './ServicePage';
export default function RemodelingMiami() {
  return <ServicePage slug="remodeling-miami" />;
}
